'use client'

import { useEffect, useState } from 'react'
import { Text, Cell, Button, Icon } from '@vinted/web-ui'
import { InfoCircle16 } from '@vinted/monochrome-icons'

import {
  clickEvent,
  MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN,
  MANUAL_DELAYED_PUBLICATION_SCREEN,
  viewScreenEvent,
} from '@marketplace-web/delayed-publication/manual-delayed-publication-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import ManualDelayedPublicationModal from '../ManualDelayedPublicationModal'

const ManualDelayedPublicationStatusBox = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const { track } = useTracking()

  const translate = useTranslate('manual_delayed_publication.status_box')

  useEffect(() => {
    track(viewScreenEvent({ screen: MANUAL_DELAYED_PUBLICATION_SCREEN }))
  }, [track])

  const handleModalClose = () => {
    setIsModalVisible(false)

    track(
      clickEvent({
        target: 'manual_delayed_publication_modal_dismiss',
        screen: MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN,
      }),
    )
  }

  const handleInfoClick = () => {
    setIsModalVisible(true)

    track(
      viewScreenEvent({
        screen: MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN,
      }),
    )
  }

  return (
    <>
      <Cell theme="amplified" testId="item-status-manual-delayed-publication">
        <div className="u-flexbox u-align-items-center">
          <Text as="h2" text={translate('title')} type="title" theme="inherit" inline />
          <Button
            icon={<Icon name={InfoCircle16} color="greyscale-level-5" />}
            size="small"
            styling="flat"
            onClick={handleInfoClick}
            title="Show additional information"
            testId="item-status-manual-delayed-publication-info-button"
            inline
          />
        </div>
      </Cell>
      <ManualDelayedPublicationModal isOpen={isModalVisible} onClose={handleModalClose} />
    </>
  )
}

export default ManualDelayedPublicationStatusBox
